export { SensorType } from '@innovyze/shared-utils';
export var Resolutions;
(function (Resolutions) {
    Resolutions["RAW"] = "RAW";
    Resolutions["15-MINUTE"] = "15-MINUTE";
    Resolutions["30-MINUTE"] = "30-MINUTE";
    Resolutions["HOURLY"] = "HOURLY";
    Resolutions["DAILY"] = "DAILY";
    Resolutions["WEEKLY"] = "WEEKLY";
    Resolutions["MONTHLY"] = "MONTHLY";
})(Resolutions || (Resolutions = {}));
